import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2" }
const _hoisted_2 = { class: "card border-light" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = {
  key: 0,
  class: "error-message"
}
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["alert alert-success alert-dismissible mail-alert", { 'show-alert': _ctx.mailSent }])
    }, [
      _createVNode(_component_router_link, {
        to: "#",
        class: "btn-close btn-close-white",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.closeAlert()))
      }),
      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "notification-text text-center" }, "Sent successfully", -1))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["alert alert-danger alert-dismissible mail-alert", { 'show-alert': _ctx.mailSendFailure }])
    }, [
      _createVNode(_component_router_link, {
        to: "#",
        class: "btn-close text-dark",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.closeAlert()))
      }),
      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "danger-text text-center" }, "Failed to send. Please reload the page and try again. If the problem persists, please email info@intelligentrx.com", -1))
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "card-body",
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[9] || (_cache[9] = _createElementVNode("label", {
            for: "nameInput",
            class: "form-label"
          }, "Name", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "nameInput",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event)),
            style: {"background-color":"var(--background-color-gray)","color":"black"}
          }, null, 512), [
            [_vModelText, _ctx.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            for: "emailInput",
            class: "form-label"
          }, "Email", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: "form-control",
            id: "emailInput",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
            style: {"background-color":"var(--background-color-gray)","color":"black"}
          }, null, 512), [
            [_vModelText, _ctx.email]
          ]),
          (!$options.validateEmail)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Please enter a valid email address "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[11] || (_cache[11] = _createElementVNode("label", {
            for: "messageInput",
            class: "form-label"
          }, "Message", -1)),
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control",
            id: "messageInput",
            rows: "3",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.message) = $event)),
            style: {"background-color":"var(--background-color-gray)","color":"black"}
          }, null, 512), [
            [_vModelText, _ctx.message]
          ])
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn irx-btn-primary w-100",
          style: {"background-color":"var(--primary-color)","border-radius":"20px !important"},
          disabled: !$options.validateEmail,
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($options.sendEmail && $options.sendEmail(...args)))
        }, " Submit ", 8, _hoisted_7)
      ], 32),
      _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-center" }, "Do NOT submit personal health information through this form! If you need help with a specific health question, please call us at 1-800-484-3487", -1))
    ]),
    (_ctx.showSpinner)
      ? (_openBlock(), _createBlock(_component_loading_spinner, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}